import ZH from "flmall/zh";
const SKIP_SELECTOR = 'input, textarea, script, style, .ace_editor, .cm-editor, .cm-content, [contenteditable="true"]';
const translateExact = (value) => {
  if (!value) {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > 240 || !ZH[trimmed]) {
    return null;
  }
  return value.replace(trimmed, ZH[trimmed]);
};
const translateElement = (el) => {
  ["placeholder", "title", "aria-label"].forEach((attr) => {
    const next = translateExact(el.getAttribute(attr));
    if (next) {
      el.setAttribute(attr, next.trim());
    }
  });
};
const walk = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    const next = translateExact(node.nodeValue);
    if (next && next !== node.nodeValue) {
      node.nodeValue = next;
    }
    return;
  }
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return;
  }
  const el = node;
  if (el.matches(SKIP_SELECTOR) || el.closest(".ace_editor, .cm-editor")) {
    return;
  }
  translateElement(el);
  Array.from(el.childNodes).forEach(walk);
};
export const startChineseUi = () => {
  if (typeof document === "undefined") {
    return;
  }
  document.documentElement.lang = "zh-CN";
  if (!document.title || document.title === "Graylog") {
    document.title = "\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0";
  }
  let timer = 0;
  const run = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (!document.body) {
        return;
      }
      walk(document.body);
      if (document.title === "Graylog" || document.title.endsWith("Graylog")) {
        document.title = document.title.replace(/Graylog/g, "\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0");
      }
    }, 30);
  };
  const boot = () => {
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["placeholder", "title", "aria-label"]
    });
  };
  if (document.body) {
    boot();
  } else {
    document.addEventListener("DOMContentLoaded", boot);
  }
};
